import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { IDocumentByIdInputModel, IDocumentApprovalModel, IElementInputModel } from 'src/app/ViewModel/DocumentModel';
import { formatDate } from '@angular/common';
import { IProjectElementDetailsOutput, IProjectFeatureOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { CommonService } from 'src/app/Service/Common.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { EmployeeCartDialogComponent } from '../employee-cart-dialog/employee-cart-dialog.component';
import { Module } from 'src/app/Service/element-details.data.service';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { CreateMessageComponent } from '../../communication/create-message/create-message.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';

@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.css']
})
export class DocumentViewComponent implements OnInit, OnDestroy {
  private _viewData!: any[];
  get viewData(): any {
    return this._viewData;
  }
  @Input() set viewData(value: any) {
    if (!!value && typeof value == "object") {
      this._viewData = value;
      this.loadData();
    }
  }

  @Input() set ViewOnly(value: boolean | undefined) {
    if (!!value) {
      this._ViewOnly = value;
    }
  }

  @ViewChild(DynamicFormComponent) dynamicForm!: DynamicFormComponent;

  _ViewOnly: boolean = false;
  public projectElements: IProjectElementsOutput[] = [];
  public documentElements: IElementInputModel[] = [];
  public regConfig: FieldConfig[] = [];
  public projectId!: number;
  public groupId!: number;
  public isRejected: boolean = false;
  public documentId!: number;
  public revisionNo!: string;
  public memberId: number = 0;
  public approverId: number = 0;
  public canApprove!: boolean;
  public canShare!: boolean;
  public data: any[] = [];
  public printsizelist: IProjectElementDetailsOutput[] = [];
  public statusList: IProjectElementDetailsOutput[] = [];
  public approverList: IProjectFeatureOutput[] = [];
  public locationList: IProjectElementDetailsOutput[] = [];
  public buildingList: IProjectElementDetailsOutput[] = [];
  public floorList: IProjectElementDetailsOutput[] = [];
  public rackList: IProjectElementDetailsOutput[] = [];
  public shelfList: IProjectElementDetailsOutput[] = [];
  UnsubscribeArray: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private _docService: DocumentService,
    private _notificationService: NotificationService,
    private _projService: ProjectInfoService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
  }
  async loadData() {
    this.isRejected = this.viewData[0].trans_type == 'Rejected' ? false : true;
    let docData = this.viewData[0];
    if (!!docData) {
      if (this.documentId != docData.docId) {
        this.projectId = docData.projectId;
        this.groupId = docData.groupId;
        this.documentId = docData.docId;
        this.revisionNo = docData.revisionNo;
        this.canShare = docData.canShare;
        this.getDocument();
      }
    }
  }

  


  public getDocument() {
    let inputModel: IDocumentByIdInputModel = {
      projectId: this.projectId,
      groupId: this.groupId,
      docId: this.documentId,
      revisionNo: this.revisionNo
    };
    let getDoc = this._docService.getDocumentById(inputModel).subscribe(x => {
      this.data = [];
      this.data.push({
        docId: x['docId'],
        docNo: x['documentNo'],
        title: x['title'],
        docDate: formatDate(x['docDate'], 'dd-MM-yyyy', 'en-US'),
        revision: x['revision'],
        nextRevision: x['nextRevision'],
        printSize: x['printSize'],
        status: x['status'],
        createdBy: x['createdBy'],
        createdByName: x['createdByName'],
        authorizedBy: x['authorisedBy'],
        docAuthorizedByName: x['docAuthorizedByName'],
        createdOn: x['createdOn'],
        revisiedOn: formatDate(x['revisedOn'], 'dd-MM-yyyy', 'en-US'),
        reviewedOn: x['reviewedOn'],
        comments: x['comments'],
        reference: x['reference'],
        isFileAttached: x['isFileAttached'],
        qrCodeStatus: x['qrCodeStatus'],
        isConfidential: x['isConfidential'],
        location: x['location'],
        building: x['building'],
        floor: x['floor'],
        rack: x['rack'],
        shelf: x['shelf'],
        fileNo: x['fileNo'] == null ? '-' : x['fileNo'],
      });
      this.approverId = x['authorisedBy'];
      this.getDocumentElements();
      this.getprintsizelist();
      this.getStatusList();
      this.getApproverList();
      this.getLocationList();
      this.getBuildingList();
      this.getFloorList();
      this.getRackList();
      this.getShelfList();
      this.checkApproval();
    });
    this.UnsubscribeArray.push(getDoc);
  }

  getDocumentElements() {
    let getDocelements = this._docService.getDocumentElementsById({ docId: this.documentId }).subscribe(
      (pde: IElementInputModel[]) => {
        this.documentElements = pde;
        this.getDynamicForm();
      });
    this.UnsubscribeArray.push(getDocelements);
  }

  getDynamicForm() {
    let getdynamicform = this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.regConfig = res.map(x => {
          let field: FieldConfig = {
            type: "label",
            label: x.projectElementDescription != null && x.projectElementDescription != '' ? x.projectElementDescription : x.elementDescription,
            de_id: x.elementId
          }
          let dedValue = this.documentElements.find(el => el.deId == x.elementId);
          if (!!dedValue) {
            field.value = new BehaviorSubject(dedValue.dedDescription);
          }
          return field;
        });
        this.dynamicForm.fields = this.regConfig;
        this.dynamicForm.createControl();
      });
    this.UnsubscribeArray.push(getdynamicform);
  }

  public getprintsizelist() {
    let getprintsize = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Print Size' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.printsizelist = res;
      }, err => { });
    this.UnsubscribeArray.push(getprintsize);
  }

  public getSelectedPrintsize(printSize: number) {
    let printSizeVal: string = '';
    if (this.printsizelist.length > 0) {
      let result = this.printsizelist.filter(x => x.dedId == printSize);
      if (result.length > 0) {
        printSizeVal = result[0].dedDescription;
      }
    }
    return printSizeVal;
  }

  public getStatusList() {
    let getstatuslist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Status' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.statusList = res;
      }, err => { });
    this.UnsubscribeArray.push(getstatuslist);
  }

  public getSelectedStatus(data: number) {
    let statusVal: string = '';
    if (this.statusList.length > 0) {
      let result = this.statusList.filter(x => x.dedId == data);
      if (result.length > 0) {
        statusVal = result[0].dedDescription;
      }
    }
    return statusVal;
  }

  public getApproverList() {
    let getapproverlist = this._projService.getProjectFeatureWiseMembers({ projectId: this.projectId, groupId: this.groupId, featureDescription: 'Approve' })
      .subscribe((res: IProjectFeatureOutput[]) => {
        this.approverList = res;
      }, err => { });
    this.UnsubscribeArray.push(getapproverlist);
  }

  public getLocationList() {
    let getlocationlist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Location' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.locationList = res;
      }, err => { });
    this.UnsubscribeArray.push(getlocationlist);
  }

  public getSelectedLocation(data: number) {
    let result = this.locationList.filter(x => x.dedId == data);
    if (result.length > 0) {
      return result[0].dedDescription;
    }
    else {
      return '-';
    }
  }

  public getBuildingList() {
    let getbuildinglist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Building' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.buildingList = res;
      }, err => { });
    this.UnsubscribeArray.push(getbuildinglist);
  }

  public getSelectedBuilding(data: number) {
    let result = this.buildingList.filter(x => x.dedId == data);
    if (result.length > 0) {
      return result[0].dedDescription;
    }
    else {
      return '-';
    }
  }

  public getFloorList() {
    let getfloorlist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Floor' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.floorList = res;
      }, err => { });
    this.UnsubscribeArray.push(getfloorlist);
  }

  public getSelectedFloor(data: number) {
    let result = this.floorList.filter(x => x.dedId == data);
    if (result.length > 0) {
      return result[0].dedDescription;
    }
    else {
      return '-';
    }
  }

  public getRackList() {
    let getracklist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Rack' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.rackList = res;
      }, err => { });
    this.UnsubscribeArray.push(getracklist);
  }

  public getSelectedRack(data: number) {
    let result = this.rackList.filter(x => x.dedId == data);
    if (result.length > 0) {
      return result[0].dedDescription;
    }
    else {
      return '-';
    }
  }

  public getShelfList() {
    let getshelflist = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Shelf' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.shelfList = res;
      }, err => { });
    this.UnsubscribeArray.push(getshelflist);
  }

  public getSelectedShelf(data: number) {
    let result = this.shelfList.filter(x => x.dedId == data);
    if (result.length > 0) {
      return result[0].dedDescription;
    }
    else {
      return '-';
    }
  }

  /**
   * File attachment for each row documents in grid
   * @param data
   */
  attachmentClick() {
    this.dialog.open(FileListComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '70%',
      data: { projectId: this.projectId, docId: this.documentId, revisionNo: this.revisionNo, libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, isDeleteEnable: false, documentNo: this.data[0].docNo },
    });
  }

  approveDocument(isApproved: any) {
    let inputModel: IDocumentApprovalModel = {
      DocId: this.documentId,
      RevisionNo: this.revisionNo,
      RevisedOn: this.data[0].revisedOn,
      IsApproved: isApproved,
      ApprovedBy: this.memberId
    };
    let approvedoc = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this._notificationService.showToast(res.successMessage, "Success");
      }
      else if (res.successCode == 500) {
        this._notificationService.showToast(res.successMessage, "Error");
      }
    });
    this.UnsubscribeArray.push(approvedoc);
  }

  shareDocument() {
    let shareDocList = [{
      docId: this.documentId, revision: this.revisionNo
    }];
    const dialogRef = this.dialog.open(EmployeeCartDialogComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '85%',
      data: { projectId: this.projectId, groupId: this.groupId, docList: shareDocList, userId: this.memberId }
    });
  }

  createMessageClick() {
    let selectedDocuments = [];
    let item = {
      docId: this.data[0].docId,
      documentNo: this.data[0].docNo,
      title: this.data[0].title,
      revision: this.data[0].revision,
      authorisedByName: this.data[0].docAuthorizedByName,
      createdByName: this.data[0].createdByName
    }
    selectedDocuments.push(item);
    const dialogRef = this.dialog.open(CreateMessageComponent, {
      panelClass: 'mat-dialog-primary',
      data: { inputType: 'createDocumentMail', selectedList: selectedDocuments }
    });
  }
  checkApproval() {
    if (this.canShare) {
      this.canApprove = false;
    }
    else {
      this.canApprove = this.memberId == this.approverId;
    }
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}


